// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"071d770d","231":"f8c1212e","360":"e8ffcd43","382":"55df2830","523":"110bc422","685":"8a4028e6","721":"a5961e33","723":"47a74d13","770":"4e7a1ccc","828":"3642d09a","851":"30aed8ec","966":"700aee68"}[chunkId] + ".chunk.js";
};